import { render, staticRenderFns } from "./exhibition-product-item.vue?vue&type=template&id=4bf0b12a&"
import script from "./exhibition-product-item.vue?vue&type=script&lang=js&"
export * from "./exhibition-product-item.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-product-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports